"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivatePointResponseSchema = exports.AdditionalPointResponseSchema = void 0;
var zod_1 = require("zod");
exports.AdditionalPointResponseSchema = zod_1.z.object({
    balance: zod_1.z.number(),
    accountType: zod_1.z.string(),
});
exports.ActivatePointResponseSchema = zod_1.z.object({
    code: zod_1.z.string(),
    message: zod_1.z.string(),
});
